<template>
 <div class="cursor_box">
                  <div class="new_cate_box">
                     <div class="flex_up_ico">
                  <allergiBlock :allergi="boxdata.allergy"></allergiBlock>
                <!-- option partial -->
                <optionBlock :option="boxdata.options"></optionBlock>
                </div>
                     <div class="box_content">
                           <div class="img_cate">
                          <imgBlock :image-url="boxdata.image"> </imgBlock>
                      </div>
                    <div class="text_wrapps">
                        <div class="name_cate">
                          <span class="cate_tit">{{boxdata.name}}</span>
                      </div>
                      <div class="desc_box">
                        {{boxdata.desc}}  
                        <span v-for="entres in  boxdata.entrees" :key="entres.id" class="entress_free">
                        +{{entres.name}}
                        </span>
                        <span class="note">
                          {{boxdata.note}}  
                        </span>
                      </div>
                    </div>
                     </div>
                        <span class="price_style_1" >{{boxdata.start_price}}<sub>{{setting.payment.currency}}</sub></span>
                    <!-- spicy partial  -->
                    <spicyBlock :spicy="boxdata.spicy"></spicyBlock>
                  </div>
                   <div class="btn_add_cate">
                          <cartBlock :cartbtn="boxdata"></cartBlock>
                    </div>
</div>
</template>
<script>
import imgBlock from '@/components/meny/block/img.vue';
import allergiBlock from '@/components/meny/block/allergi.vue';
import optionBlock from '@/components/meny/block/option.vue';
import cartBlock from '@/components/meny/block/addcart.vue';
import spicyBlock from '@/components/meny/block/spicy.vue';
export default {
 name:'halfhalf_box',
 props:['boxdata', 'setting'],
components:{imgBlock , allergiBlock , optionBlock, cartBlock,spicyBlock},
}
</script>
